// extracted by mini-css-extract-plugin
export default {"main":"settings_main__edzkM","row":"settings_row__mVciG","label":"settings_label__0Be6V","button":"settings_button__k1v4G"};